module.exports = __webpack_public_path__ + "static/media/slider-4.228bcb2a.jpg";